<div class="page-loading-wait" *ngIf="displayLoading">
    <img src="../../../assets/img/cf_logo_icon_new.png" class="loading-icon spinner" />
</div>

<div class="row text-left">
    <div class="col-md-12">
        <div class="card">
            <form class="pl-3 pr-3 pb-3 my-3" [formGroup]="labSamplesForm"
                (submit)="$event.preventDefault(); onClickSave('save')">
                <h5>Lab Samples 
                    <span style="font-size: 0.7rem;" [ngClass]="{
                        badge: true,
                        'badge-info': sampleStatus === 'NEW',
                        'badge-warning': sampleStatus === 'AWAITING VALIDATION',
                        'badge-success': sampleStatus === 'APPROVED',
                        'badge-secondary': sampleStatus === 'PENDING REVIEW' || sampleStatus === 'ARCHIVED',
                        'badge-danger': sampleStatus === 'REJECTED',
                        'regenerated': sampleStatus === 'REGENERATED'
                      }" *ngIf="pagetype === 'edit'">
                        {{ sampleStatus }}
                    </span>
                    <button (click)="handleAction()" class="btn btn-primary ml-2" *ngIf="isMobile && !disableSamplePointCode">
                          Add Sample Point Code
                    </button> 
                </h5>
                
                <div *ngIf="isMobile">
                    <zxing-scanner [device]="selectedDevice" (scanSuccess)="onCodeResult($event)">
                    </zxing-scanner>
                </div>
                <div class=" form-row">
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-1" style="text-transform: none;" class="required">Sample Point
                                Code</label>
                            <ng-select [(ngModel)]="selectedSample" [ngModelOptions]="{standalone: true}"
                                [clearable]="true" [disabled]="disableSamplePointCode || pagetype === 'edit'" (change)="samplerPointSelection()" (search)="onenterSamplePointCode($event)">
                                <ng-option *ngFor="let option of filteredSamplePointCode" [value]="option">{{ option.SAMPLE
                                    }}</ng-option>
                            </ng-select>
                            <div *ngIf="labSamplesForm.get('samplePointCode').touched && labSamplesForm.get('samplePointCode').invalid"
                                class="text-danger">

                                Sample Point Code is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-3" style="text-transform: none;">Sample Point
                                Name</label>
                            <input type="text" id="basic-form-3" class="form-control" name="samplePointName"
                                formControlName="samplePointName" readonly>

                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-1" style="text-transform: none;">{{ labSampleLabelMap['Meter #'] || 'Meter #' }}</label>
                            <input type="text" id="basic-form-1" class="form-control" name="workOrder"
                                formControlName="workOrder">
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-2" style="text-transform: none;">{{labSampleLabelMap['Lab File Number'] || 'Lab File Number'}}</label>
                            <input type="text" id="basic-form-2" class="form-control" name="fileNumber"
                                formControlName="labFileNumber" readonly>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-6" style="text-transform: none;">{{labSampleLabelMap['Container Number'] || 'Container Number'}}</label>
                            <input type="text" id="basic-form-2" class="form-control" name="containerNumber"
                                formControlName="containerNumber">
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Source Lab'] || 'Source Lab'}}</label>
                            <select id="basic-form-7" name="sourceLab" class="form-control" formControlName="sourceLab">
                                <option value="Premier Measurement and Laboratory Services" selected>Premier Measurement and Laboratory Services</option>
                                <option value="Sample Services">Sample Services</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                </div>
                <br>
                <h5>Sampling Information</h5>
                <div class=" form-row">
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-1" style="text-transform: none;">{{labSampleLabelMap['Sampler'] || 'Sampler'}}</label>
                            <input type="text" id="basic-form-1" class="form-control" name="samplerName"
                                formControlName="samplerName">
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Source Description'] || 'Source Description'}}</label>
                            <input type="text" id="basic-form-2" class="form-control" name="sourceDescription"
                                formControlName="sourceDescription">
                        </div>
                    </div>

                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;" class="required">
                               {{labSampleLabelMap['Date Sampled'] || 'Date Sampled'}} </label>
                            <input type="date" id="basic-form-5" class="form-control" name="sampleDate"
                                formControlName="sampleDate" [max]="currentDate">
                            <div *ngIf="labSamplesForm.get('sampleDate').touched && labSamplesForm.get('sampleDate').invalid"
                                class="text-danger">
                                Date Sampled is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Sampled Time'] || 'Sampled Time'}}</label>
                            <input type="time" id="basic-form-5" class="form-control" name="sampleTime"
                                formControlName="sampleTime">
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Sample End Date'] || 'Sample End Date'}}</label>
                            <input type="date" id="basic-form-5" class="form-control" name="sampleEndDate"
                                formControlName="sampleEndDate">
                        </div>
                    </div>

                </div>
                <div class="form-row">
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Sampling Method'] || 'Sampling Method'}}</label>
                            <input type="text" id="basic-form-2" class="form-control" name="samplingMethod"
                                formControlName="samplingMethod">
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Company Collecting Sample'] || 'Company Collecting Sample'}}</label>
                            <input type="text" id="basic-form-2" class="form-control" name="companyCollectingSample"
                                formControlName="companyCollectingSample">
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Source Pressure'] || 'Source Pressure'}}</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="sourcePressure">
                                <div ngbDropdown class="input-group-append dropup">
                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        {{ labSamplesForm.get('sourcePressureUnit').value || 'Unit' }}
                                    </button>
                                    <div class="dropdown-menu" ngbDropdownMenu>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('sourcePressureUnit').setValue('PSI')">PSI</a>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('sourcePressureUnit').setValue('PSIG')">PSIG</a>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('sourcePressureUnit').setValue('PSIA')">PSIA</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Source Temperature'] || 'Source Temperature'}}</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="sourceTemperature">
                                <div ngbDropdown class="input-group-append dropup">
                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        {{ labSamplesForm.get('sourceTemperatureUnit').value || 'Unit' }}
                                    </button>
                                    <div class="dropdown-menu" ngbDropdownMenu>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('sourceTemperatureUnit').setValue('°F')"><sup>o</sup>F</a>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('sourceTemperatureUnit').setValue('K')">K</a>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('sourceTemperatureUnit').setValue('°C')"><sup>o</sup>C</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Ambient Temperature'] || 'Ambient Temperature'}}</label>
                            <fieldset>
                                <div class="input-group">
                                    <input type="text" class="form-control" name="ambientTemperature"
                                        formControlName="ambientTemperature">
                                    <div ngbDropdown class="input-group-append dropup">
                                        <button type="button" class="btn btn-primary dropdown-toggle"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            ngbDropdownToggle>
                                            {{ labSamplesForm.get('ambientTemperatureUnit').value || 'Unit' }}
                                        </button>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('ambientTemperatureUnit').setValue('°F')"><sup>o</sup>F</a>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('ambientTemperatureUnit').setValue('K')">K</a>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('ambientTemperatureUnit').setValue('°C')"><sup>o</sup>C</a>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;" class="required">{{labSampleLabelMap['Base Pressure'] || 'Base Pressure'}}</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="basePressure" [readOnly]="pagetype === 'edit'">
                                <div ngbDropdown class="input-group-append dropup" >
                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" [disabled]="pagetype === 'edit'"
                                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        {{ labSamplesForm.get('basePressureUnit').value || 'Unit' }}
                                    </button>
                                    <div class="dropdown-menu" ngbDropdownMenu>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('basePressureUnit').setValue('PSI')">PSI</a>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('basePressureUnit').setValue('PSIG')">PSIG</a>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('basePressureUnit').setValue('PSIA')">PSIA</a>
                                    </div>
                                </div>
                               
                            </div>
                            <div *ngIf="labSamplesForm.get('basePressure').touched && labSamplesForm.get('basePressure').invalid"
                            class="text-danger">
                            Base Pressure is required
                        </div>
                           
                        </div>
                    </div>
                    <div *ngIf="isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;" class="required">{{labSampleLabelMap['Base Pressure'] || 'Base Pressure'}}</label>
                             <ng-select  formControlName="basePressure" [ngModelOptions]="{standalone: true}" [disabled]="pagetype === 'edit'"
                                [clearable]="false">
                                <ng-option value="14.73">14.65 PSI</ng-option>
                                <ng-option value="14.73">14.696 PSI</ng-option>
                                <ng-option value="14.73">14.73 PSI</ng-option>
                            </ng-select>
                            <div *ngIf="labSamplesForm.get('basePressure').touched && labSamplesForm.get('basePressure').invalid"
                            class="text-danger">
                            Base Pressure is required
                        </div>
                           
                        </div>
                    </div>

                </div>
                <div class="form-row">
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Flow Rate'] || 'Flow Rate'}}</label>
                            <fieldset>
                                <div class="input-group">
                                    <input type="text" class="form-control" name="flowRate" formControlName="flowRate">

                                    <div ngbDropdown class="input-group-append dropup">
                                        <button type="button" class="btn btn-primary dropdown-toggle"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                            ngbDropdownToggle>
                                            {{ labSamplesForm.get('flowRateUnit').value || 'Unit' }}
                                        </button>
                                        <div class="dropdown-menu" ngbDropdownMenu>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('flowRateUnit').setValue('Mcf')">Mcf</a>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('flowRateUnit').setValue('Scf')">Scf</a>
                                            <a ngbDropdownItem href="javascript:;"
                                                (click)="labSamplesForm.get('flowRateUnit').setValue('Bcf')">Bcf</a>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Field H<sub>2</sub>S Value</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="fieldH2SValue">
                                <div ngbDropdown class="input-group-append dropup">
                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        {{ labSamplesForm.get('fieldH2SValueUnit').value || 'Unit' }}
                                    </button>
                                    <div class="dropdown-menu" ngbDropdownMenu>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('fieldH2SValueUnit').setValue('PPM')">PPM</a>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('fieldH2SValueUnit').setValue('%')">%</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Field H<sub>2</sub>S Method</label>
                            <!-- <div class="input-group">
                                <select id="basic-form-7" name="sourceLab" class="form-control"
                                    formControlName="fieldH2SMethod">
                                    <option value="PURGE AND FILL" selected>PURGE AND FILL</option>
                                    <option value="HELIUM POP">HELIUM POP</option>
                                    <option value="WATER DISPLACEMENT">WATER DISPLACEMENT</option>
                                    <option value="CONTINUOUS PURGE">CONTINUOUS PURGE</option>
                                    <option value="FLOATING PISTON CYLINDER">FLOATING PISTON CYLINDER
                                    </option>
                                </select>
                            </div> -->

                            <input type="text" id="basic-form-2" class="form-control" name="fieldH2SMethod"
                                formControlName="fieldH2SMethod">
                        </div>
                    </div>
                    <!-- <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Field H<sub>2</sub>O Value</label>
                            <div class="input-group">
                                <input type="text" class="form-control" formControlName="fieldH2OValue">
                                <div ngbDropdown class="input-group-append dropup">
                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                        {{ labSamplesForm.get('fieldH2OValueUnit').value || 'Unit' }}
                                    </button>
                                    <div class="dropdown-menu" ngbDropdownMenu>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('fieldH2OValueUnit').setValue('PPM')">PPM</a>
                                        <a ngbDropdownItem href="javascript:;"
                                            (click)="labSamplesForm.get('fieldH2OValueUnit').setValue('%')">%</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Field H<sub>2</sub>O Method</label>
                            <input type="text" id="basic-form-2" class="form-control" name="fieldH2OMethod"
                                formControlName="fieldH2OMethod">
                        </div>
                    </div> -->
                    
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-7" style="text-transform: none;">{{labSampleLabelMap['Lease'] || 'Lease'}}</label>
                            <input type="text" id="basic-form-2" class="form-control" name="lease"
                                formControlName="lease">
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Base Temperature'] || 'Base Temperature'}}</label>
                            <input type="text" disabled id="basic-form-5" class="form-control" name="baseTemperature"
                                formControlName="baseTemperature">
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Calibiration Date'] || 'Calibiration Date'}}</label>
                            <input type="date" id="basic-form-5" class="form-control" name="calibarationDate"
                                formControlName="calibarationDate">
                        </div>
                    </div>
                     <div *ngIf="isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-1" style="text-transform: none;" class="required">{{labSampleLabelMap['Sample State'] || 'Sample State'}}</label>
                            <ng-select [(ngModel)]="selectedSampleState" [ngModelOptions]="{standalone: true}"
                                [clearable]="false" (change)="generateLabFileNumber()" [disabled]="pagetype === 'edit'">
                                <ng-option value="G">Gas</ng-option>
                                <ng-option value="L">Liquid</ng-option>
                            </ng-select>
                            <div *ngIf="labSamplesForm.get('sampleState').touched && labSamplesForm.get('sampleState').invalid"
                                class="text-danger">
                                Sample State is required
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-2" style="text-transform: none;">{{labSampleLabelMap['Sample Type'] || 'Sample Type'}}</label>
                            <select id="basic-form-7" name="sampleType" class="form-control"
                                formControlName="sampleType" (change)="samplerTypeSelection($event)">
                                <option value="Spot" selected>Spot</option>
                                <option value="Composite">Composite</option>
                            </select>
                        </div>
                    </div>
                    <div *ngIf="isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['Base Temperature'] || 'Base Temperature'}}</label>
                            <input type="text" disabled id="basic-form-5" class="form-control" name="baseTemperature"
                                formControlName="baseTemperature">
                        </div>
                    </div>
                </div>
                <div class="form-row">

                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-1" style="text-transform: none;" class="required">{{labSampleLabelMap['Sample State'] || 'Sample State'}}</label>
                            <ng-select [(ngModel)]="selectedSampleState" [ngModelOptions]="{standalone: true}"
                                [clearable]="false" (change)="generateLabFileNumber()" [disabled]="pagetype === 'edit'">
                                <ng-option value="G">Gas</ng-option>
                                <ng-option value="L">Liquid</ng-option>
                            </ng-select>
                            <div *ngIf="labSamplesForm.get('sampleState').touched && labSamplesForm.get('sampleState').invalid"
                                class="text-danger">
                                Sample State is required
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-2" style="text-transform: none;">{{labSampleLabelMap['Sample Type'] || 'Sample Type'}}</label>
                            <select id="basic-form-7" name="sampleType" class="form-control"
                                formControlName="sampleType" (change)="samplerTypeSelection($event)">
                                <option value="Spot" selected>Spot</option>
                                <option value="Composite">Composite</option>
                            </select>
                        </div>
                    </div>


                    <div class="col-md-2 col-12" *ngIf="isComposite">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['From Date'] || 'From Date'}}</label>
                            <input type="date" id="basic-form-5" class="form-control" name="fromDate"
                                formControlName="fromDate">
                        </div>
                    </div>
                    <div class="col-md-2 col-12" *ngIf="isComposite">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">{{labSampleLabelMap['End Date'] || 'End Date'}}</label>
                            <input type="date" id="basic-form-5" class="form-control" name="toDate"
                                formControlName="endDate">
                        </div>
                    </div>
                    
                    <!-- <div *ngIf="isMobile" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Time Collected</label>
                            <input type="time" id="basic-form-5" class="form-control" name="timeCollected"
                                formControlName="timeCollected">
                        </div>

                    </div> -->
                    <div *ngIf="isMobile" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Condition</label>
                            <input type="text" id="basic-form-5" class="form-control" name="sampleCondition"
                                formControlName="sampleCondition">
                        </div>

                    </div>
                    <div *ngIf="isMobile" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Additional Notes</label>
                            <input type="text" id="basic-form-5" class="form-control" name="additionalNotes"
                                formControlName="additionalNotes">
                        </div>

                    </div>
                    <div *ngIf="isMobile">
                        <div class="form-group mb-2">
                            <label for="upload">Upload a picture</label>
                            <input type="file" (change)="onUploadImage($event)" id="upload" accept=".jpg,.jpeg,.png" />
                        </div>
                    </div>

                    <!-- <div class="col-md-2 col-12" *ngIf="showCalibirationDate">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Laboratory</label>
                            <input type="text" id="basic-form-5" class="form-control" name="laboratory"
                                formControlName="laboratory">
                        </div>
                    </div>
                    <div class="col-md-2 col-12" *ngIf="showCalibirationDate">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Technician</label>
                            <input type="text" id="basic-form-5" class="form-control" name="technician"
                                formControlName="technician">
                        </div>
                    </div> -->
                </div>
                <br>
                <h5>Required Tests</h5>
                <div class="form-row">
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-1" style="text-transform: none;">Report Type </label>
                            <select id="basic-form-7" name="reportType" class="form-control" 
                                [attr.disabled]="pagetype === 'edit' ? true : null"
                                formControlName="reportType">
                                <option value="C6" selected>C6</option>
                                <option value="C9">C9</option>
                                <option value="Extended">Extended</option>
                                <option value="Sulfur">Sulfur</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-2" style="text-transform: none;" class="required">Tests</label>
                            <select id="basic-form-7" name="reportTests" class="form-control" (change)="reportTypeSelection($event)"
                                formControlName="reportTests" [attr.disabled]="pagetype === 'edit' ? true : null">
                                <option *ngFor="let option of availableReportTests" [value]="option.value">{{ option.title
                                    }}</option>
                            </select>
                            <div *ngIf="labSamplesForm.get('reportTests').touched && labSamplesForm.get('reportTests').invalid"
                                class="text-danger">
                                Test is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">Others</label>
                            <select id="basic-form-7" name="reportOthers" class="form-control"
                                formControlName="reportOthers">
                                <option value="">--No option--</option>
                                <option value="rush" selected>Rush</option>
                            </select>
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">C6 Composition</label>
                            <input type="input" id="basic-form-5" class="form-control" name="C6Composition"
                            formControlName="C6Composition">
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">C7 Composition</label>
                            <input type="input" id="basic-form-5" class="form-control" name="C7Composition"
                            formControlName="C7Composition">
                        </div>
                    </div>
                    <div *ngIf="!isCustomer" class="col-md-2 col-12">
                        <div class="form-group mb-2">
                            <label for="basic-form-5" style="text-transform: none;">C8 Composition</label>
                            <input type="input" id="basic-form-5" class="form-control" name="C8Composition"
                            formControlName="C8Composition">
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-end">
                    <button *ngIf="pagetype === 'add'" type="submit" class="btn btn-primary mr-2"><i class="ft-check-square mr-1"></i>Save</button>
                    <button *ngIf="pagetype === 'edit'" type="button" (click)="onClickUpdate()" class="btn btn-primary mr-2"><i class="ft-check-square mr-1"></i>Update</button>
                    <button type="button" class="btn btn-danger" (click)="clearForm()"><i
                            class="ft-x mr-1"></i>Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>